import HotWalletDetails from './hotWalletDetails';

export default HotWalletDetails;
